var IconSwitch = (function () {


  Utility.log('IconSwitch.js loaded');


  function init() {

    Utility.log('IconSwitch.js inited');

    try {

      var iconList;

      iconList = $('.acr-icon-change-js');

      bindEvent(iconList);


    } catch (e) {
      Utility.error(e.message);
    }
  }

  function bindEvent(iconList) {
    for (var x = 0; x < iconList.length; x++) {
      var item;
      item = iconList[x];
      if (item.dataset.acrIconChangeH) {
        var inSvg;
        var outSvg;

        inSvg = item.dataset.acrIconChangeH;
        outSvg = $(item).find('.acr-icon use').attr('xlink:href');
        bindHover(item, inSvg, outSvg);
      }
    }
  }

  function bindHover(element, inSvg, outSvg) {
    var $element;

    $element = $(element);
    $element.on('mouseenter', function () {
      $element.find('.acr-icon use').attr('xlink:href', inSvg);

    });
    $element.on('mouseleave', function () {
      $element.find('.acr-icon use').attr('xlink:href', outSvg);
    });
  }

  // Expose the following variables and functions
  return {
    init: init,
  };
}());
